export default "__VITE_ASSET___A8X6U56__"